/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';
import type { ConversationDto } from './ConversationDto';
import {
    ConversationDtoFromJSON,
    ConversationDtoFromJSONTyped,
    ConversationDtoToJSON,
    ConversationDtoToJSONTyped,
} from './ConversationDto';

/**
 * 
 * @export
 * @interface ConversationListResponseDto
 */
export interface ConversationListResponseDto {
    /**
     * List of conversations
     * @type {Array<ConversationDto>}
     * @memberof ConversationListResponseDto
     */
    conversations: Array<ConversationDto>;
    /**
     * Pagination metadata
     * @type {PaginationDto}
     * @memberof ConversationListResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the ConversationListResponseDto interface.
 */
export function instanceOfConversationListResponseDto(value: object): value is ConversationListResponseDto {
    if (!('conversations' in value) || value['conversations'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ConversationListResponseDtoFromJSON(json: any): ConversationListResponseDto {
    return ConversationListResponseDtoFromJSONTyped(json, false);
}

export function ConversationListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'conversations': ((json['conversations'] as Array<any>).map(ConversationDtoFromJSON)),
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function ConversationListResponseDtoToJSON(json: any): ConversationListResponseDto {
    return ConversationListResponseDtoToJSONTyped(json, false);
}

export function ConversationListResponseDtoToJSONTyped(value?: ConversationListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'conversations': ((value['conversations'] as Array<any>).map(ConversationDtoToJSON)),
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

